/**
 * Page utilities for basepage component
 */
export const initPageUtils = () => {
    // Set cookie function
    window.setCookie = function(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/;secure";
    };

    // Initialize gated content
    (function(g,a,t,e,d,c,o){
        if (!g[d]) {
            g.GatedContentObject=d;
            g[d]=g[d]||function(){(g[d].q=g[d].q||[]).push(arguments)}
        }
    })(window, document, 'script', 'https://app.gatedcontent.com/scripts/14319476/app.js', 'gcdc');

    // Set up load event listener for gated content
    window.addEventListener('load', () => {
        if (typeof window.gcdc === 'function') {
            window.gcdc('loadGates');
            console.info("Loading gcdc.");
        }
    });

    // Store referrer URL in cookie when allowed
    if (typeof OneTrust !== 'undefined' && OneTrust.IsAllow && OneTrust.IsAllow("C0002")) {
        setCookie("fullReferringUrl", window.location.href, 30);
    } else {
        // Set up a listener for consent changes
        document.addEventListener('consent.onetrust', function() {
            if (OneTrust.IsAllow("C0002")) {
                setCookie("fullReferringUrl", window.location.href, 30);
            }
        });
    }
};
